import type { ReactNode, ForwardedRef } from 'react';
import { forwardRef } from 'react';

import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';

import STYLES from './NoneStyleButton.scss';

type Props = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
};

const cls = cssModules(STYLES);

const NoneStyleButton = (
  { children, onClick, ...rest }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) => (
  <button
    {...rest}
    type="button"
    ref={ref}
    onClick={onClick}
    className={cls('NoneStyleButton')}
  >
    {children}
  </button>
);

export default forwardRef(NoneStyleButton);
